"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var classnames_1 = __importDefault(require("classnames"));
var page_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/page"));
var PageStore = /** @class */ (function () {
    function PageStore(props) {
        this.component = page_1.default;
        this.isActive = false;
        this.elementStores = props.elementStores;
    }
    Object.defineProperty(PageStore.prototype, "containerClassName", {
        get: function () {
            return (0, classnames_1.default)('estimateForm-Page', { 'estimateForm-Page-hidden': !this.isActive });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], PageStore.prototype, "elementStores", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], PageStore.prototype, "isActive", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], PageStore.prototype, "containerClassName", null);
    return PageStore;
}());
exports.default = PageStore;
